import {globalStore} from '../main.js'
import axios from 'axios';
import translations from '../resources/translations';

export default {
    labels: function(){
        return globalStore.culture.strings.Shared;
    },
    unlockUser: function(self, id, successCallback){
        const apiUrl = globalStore.host + "UnlockUserAccount";

        axios
        .post(apiUrl, { Email : id }, {
            headers: { Authorization: "Bearer " + self.$session.get("jwt") }
        })
        .then(response => {					
            if (response.status === 200) {
                successCallback();
                globalStore.showInfo(null, this.labels().USER_WAS_UNLOCKED, 'success');
            }
        })
        .catch(err => {
            console.log(err);
            if (err.response && err.response.status === 401) {
                self.$session.destroy();
                self.$router.push("/login");
            } else {
                globalStore.showInfo(null, this.labels().ERROR_UNLOCK_USER, 'danger')
            }
            return err;
        });		
    },
    activateUser: function(self, id, successCallback){
        const apiUrl = globalStore.host + "EnableUserAccount";

        axios
        .post(apiUrl, { Email : id }, {
            headers: { Authorization: "Bearer " + self.$session.get("jwt") }
        })
        .then(response => {					
            if (response.status === 200) {
                successCallback();
                globalStore.showInfo(null, this.labels().USER_WAS_ACTIVATED, 'success');
            }
        })
        .catch(err => {
            console.log(err);
            if (err.response && err.response.status === 401) {
                self.$session.destroy();
                self.$router.push("/login");
            } else {
                globalStore.showInfo(null, this.labels().ERROR_USER_ACTIVATION, 'danger')
            }
            return err;
        });		
    },
    deactivateUser: function(self, id, successCallback){
        const apiUrl = globalStore.host + "DisableUserAccount";
    
        axios
        .post(apiUrl, { Email : id }, {
            headers: { Authorization: "Bearer " + self.$session.get("jwt") }
        })
        .then(response => {					
            if (response.status === 200) {
                successCallback();
                globalStore.showInfo(null, this.labels().USER_WAS_DEACTIVATED, 'success')
            }
        })
        .catch(err => {
            console.log(err);
            if (err.response && err.response.status === 401) {
                self.$session.destroy();
                self.$router.push("/login");
            } else{
                globalStore.showInfo(null, this.labels().ERROR_USER_DEACTIVATION, 'danger')
            }
            return err;
        });	
    },
    sendWelcomeEmail: function(self, id, culture, appType, noPasswd) {
        var apiUrl = globalStore.host + "ResendConfirmationEmail";
        if (noPasswd) {
            apiUrl += '?withPasswordLink=false';
        }
        
        return axios
            .post(apiUrl, { Email : id, PreferredLanguage: culture, UserType: appType }, {
                headers: { Authorization: "Bearer " + self.$session.get("jwt") }
            })
            .then(response => {					
                if (response.status === 200) {
                    if(response.data == 'Email was resent successfully'){
                        globalStore.showInfo(null, this.labels().EMAIL_WAS_SENT, 'success');
                    } else if(response.data.indexOf('Email was not resent') > -1){
                        globalStore.showInfo(null, this.labels().EMAIL_NOT_SENT_USER_ACTIVE, 'success');
                    } else{
                        globalStore.showInfo(null, this.labels().ERROR_EMAIL_SEND, 'danger');
                        console.log(response.data);
                    }
                }
                return response;
            })
            .catch(err => {
                console.log(err);
                if (err.response) {
                    if (err.response.status === 401) {
                        self.$session.destroy();
                        self.$router.push("/login");
                    } else if (err.response.status === 403) {
                        globalStore.showInfo(null, this.labels().PASSWORD_RESET_TOO_OFTEN, 'danger');
                    } else {
                        globalStore.showInfo(null, this.labels().ERROR_EMAIL_SEND, 'danger');
                    }
                }
                return err;
            });	
    },
    getWelcomeEmailPreview: function(self, id, appType, noPasswd) {
        const apiUrl = globalStore.host + "GetWelcomeEmailPreview/" 
            + appType
            + (noPasswd ? '/false' : '/true')
            + "?email=" + id;
        
        return axios.get(apiUrl, {
            headers: { Authorization: "Bearer " + self.$session.get("jwt") }
        });
    },
    sendForgotPasswordEmail: function(self, id, culture, userType){
        const apiUrl = globalStore.host + "ForgotPassword?force=true";
        
        axios
        .post(apiUrl, { UserName : id, Culture: culture, UserType: userType }, {
            headers: { Authorization: "Bearer " + self.$session.get("jwt") }
        })
        .then(response => {					
            if (response.status === 200) {
                globalStore.showInfo(null, this.labels().EMAIL_WAS_SENT, 'success');                
            }
        })
        .catch(err => {
            console.log(err);
            if (err.response) {
                if (err.response.status === 401) {
                    self.$session.destroy();
                    self.$router.push("/login");
                } else if (err.response.status === 403) {
                    globalStore.showInfo(null, this.labels().PASSWORD_RESET_TOO_OFTEN, 'danger');
                } else {
                    globalStore.showInfo(null, this.labels().ERROR_EMAIL_SEND, 'danger');
                }
            }
            return err;
        });	
    },
    getForgotPasswordEmailPreview: function(self, id, appType) {
        const apiUrl = globalStore.host + "GetForgotPasswordEmailPreview/" 
            + appType
            + "?email=" + id;
        
        return axios.get(apiUrl, {
            headers: { Authorization: "Bearer " + self.$session.get("jwt") }
        });
    }
};


// WEBPACK FOOTER //
// ./src/shared/userMethods.js